/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Req_R1Inputs */

const en_fc_online_req_r1 = /** @type {(inputs: Fc_Online_Req_R1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebGPU is used when available, with automatic fallback to WebGL2.`)
};

/**
* | output |
* | --- |
* | "WebGPU is used when available, with automatic fallback to WebGL2." |
*
* @param {Fc_Online_Req_R1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_req_r1 = /** @type {((inputs?: Fc_Online_Req_R1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Req_R1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_req_r1(inputs)
});
export { fc_online_req_r1 as "fc.online.req.r1" }